import actionTypes from "../actions/action-types";
import isEqual from "lodash-es/isEqual";
import {set,get} from "../utils/dotutils";

const SelectorImageReducer = (state = {}, action) => {
    const newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case actionTypes.SET_SELECTORIMAGE_STATE:
            set(newState, action.selectorimage, {...get(newState, action.selectorimage), ...action.state});
            return newState;
        default:
            return newState;
    }
};

export default SelectorImageReducer;